import React from 'react';
import { object, string } from 'yup';

import { useToast } from 'Component/Alerta';
import Form, { Botao, Campo } from 'Component/Form';
import Icone from 'Component/Icone';
import Usuario from 'Interface/Usuarios';
import { useEditarPerfilMutation } from 'Service';

const regras = object({
    senha: string().min(6, 'A senha deve ter no mínimo 6 caracteres').required('Obrigatório'),
    confirmar_senha: string()
        .required('Obrigatório')
        .test('igual', 'Deve ser igual a senha acima', (valor, contexto) => {
            if (valor) {
                return valor == contexto.parent.senha;
            }

            return true;
        }),
});

const AlterarMinhaSenha = (): React.ReactElement =>
{
    const toast = useToast();
    const [ editarUsuario ] = useEditarPerfilMutation();

    const enviar = async (dados: Usuario): Promise<void> =>
    {
        try {
            await editarUsuario(dados).unwrap();

            toast({ conteudo: 'Senha alterada com sucesso!', tema: 'success' });
        } catch (error) {
            toast({
                titulo: 'Erro ao alterar senha',
                conteudo: 'Verifique os logs para maiores detalhes.',
                tema: 'danger',
            });
        }
    }

    return (
        <div className="animate__animated animate__fadeIn" style={{ minHeight: window.outerHeight }}>
            <div className="container px-4 mt-5">
                <p className="display-1 text-center text-white">
                    Alterar minha senha
                </p>
                <p className="lead text-muted text-center">
                    Quer trocar sua senha? Aqui é o lugar para isso!
                </p>
            </div>
            <div className="container-fluid mb-5">
                <Form onSubmit={ enviar } regras={ regras }>
                    <div className="row justify-content-center mt-5 px-3">
                        <div className="col-md-4">
                            <div className="bg-white shadow-sm rounded p-4">
                                <div className="row">
                                    <div className="col-md-12">
                                        <Campo
                                            type="password"
                                            name="senha"
                                            rotulo="Senha"
                                            prefixar={ <Icone nome="lock-fill" /> }
                                        />
                                        <Campo
                                            type="password"
                                            name="confirmar_senha"
                                            rotulo="Confirmação de senha"
                                            prefixar={ <Icone nome="lock-fill" /> }
                                            ajuda="Repita a senha que você digitou acima"
                                        />
                                    </div>
                                </div>

                                <div className="mt-4">
                                    <Botao>Alterar minha senha</Botao>
                                </div>
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        </div>
    )
}

export default AlterarMinhaSenha;
